export default "__VITE_ASSET__vEoY90cZ__"